import { Reducer } from "redux";
import { CategoriesState } from "@models/category";
import {CategoriesActionTypes} from '@actions/category';
import {TagsActionTypes} from "@actions/tag";

// Type-safe initialState!
export const initialState: CategoriesState = {
  data: [],
  errors: undefined,
  loading: false
};

const reducer: Reducer<CategoriesState> = (state = initialState, action) => {
  switch (action.type) {
      case CategoriesActionTypes.FETCH_REQUEST: {
          return { ...state, loading: true };
      }

      case CategoriesActionTypes.FETCH_SUCCESS: {
          const{data, meta} = action.payload;
          return {
              ...state,
              loading: false,
              data,
              count: meta.total_count
          };
      }

      case CategoriesActionTypes.FETCH_ERROR: {
          return { ...state, loading: false, errors: action.payload };
      }


      case CategoriesActionTypes.DELETE_SUCCESS:{
          return{
              ...state,
              data : state.data.filter( tag => tag.id != action.payload.params.id),
              count: state.count - 1
          }
      }

      case CategoriesActionTypes.CREATE_SUCCESS:{
          const category = action.payload;
          return{
              ...state,
              data : [category, ...state.data],
              count: state.count + 1
          }
      }

      case CategoriesActionTypes.UPDATE_SUCCESS:{
          const category = action.payload;
          return{
              ...state,
              data : state.data.map( item => (item.id == category.id) ? {
                  ...item,
                  ...category
              } : item ),
          }
      }

    default: {
      return state;
    }
  }
};

export { reducer as categoryReducer };
